import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useQuery } from "react-query";

export function useDeviceUsersByCustomerId(customerId?: number, assetId?: number) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["deviceUsersByCustomerId", customerId, assetId],
    queryFn: async () => {
      if (customerId) return await apiContext.assignmentApis.getDeviceUsersByCustomerId(customerId, assetId ?? 0);
    },
  });
}
